import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Cloud & DevOps Engineer @ Unloq®",    // ✅ Current position (primary)
          "Building AI Infrastructure",           // ✅ What you do at Unloq
          "AWS Solutions Architect",             // ✅ Shows expertise
          "Docker & Kubernetes Specialist",      // ✅ Specific technologies
          "Infrastructure Automation Expert",    // ✅ Matches your DevOps work
          "Cloud Security Engineer",             // ✅ Matches your Docker scanner project
          "M.Tech @ IIT Patna",                 // ✅ Academic credentials
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
